var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionEyeVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon icon-eye icon-eye_visible",
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    id: "ic_action_Visible"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,5 C6.36363636,5 3.25818182,7.26181818 2,10.4545455 C3.25818182,13.6472727 6.36363636,15.9090909 10,15.9090909 C13.6363636,15.9090909 16.7418182,13.6472727 18,10.4545455 C16.7418182,7.26181818 13.6363636,5 10,5 Z M10,14.0909091 C7.99272727,14.0909091 6.36363636,12.4618182 6.36363636,10.4545455 C6.36363636,8.44727273 7.99272727,6.81818182 10,6.81818182 C12.0072727,6.81818182 13.6363636,8.44727273 13.6363636,10.4545455 C13.6363636,12.4618182 12.0072727,14.0909091 10,14.0909091 Z M10,8.27272727 C8.79272727,8.27272727 7.81818182,9.24727273 7.81818182,10.4545455 C7.81818182,11.6618182 8.79272727,12.6363636 10,12.6363636 C11.2072727,12.6363636 12.1818182,11.6618182 12.1818182,10.4545455 C12.1818182,9.24727273 11.2072727,8.27272727 10,8.27272727 Z",
    id: "path-eye",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  })))));
}
export default __webpack_public_path__ + "static/media/ic-action-eye-visible.7d848e1d.svg";
export { SvgIcActionEyeVisible as ReactComponent };